export const INBOX_ROOT_ID = 'trello-inbox-root';
export const INBOX_CONTAINER_ID = 'trello-inbox-container';
